import circleImage from '@/assets/svg/circle.svg'
import { LangText } from '@/components'
import { preFixImgUrl } from '@/utils'

const FEATURE_ITEMS = [
  {
    image: 'f5ee11bc8920518bdc99e4d6d3b19982.png',
    titleKey: 'sagawa.features.items.sameDayDelivery.title',
    descriptionKey: 'sagawa.features.items.sameDayDelivery.description',
  },
  {
    image: '380b7117ddb82b0da093f9ab5c104d91.png',
    titleKey: 'sagawa.features.items.moreTravelTime.title',
    descriptionKey: 'sagawa.features.items.moreTravelTime.description',
  },
  {
    image: 'dfedc03fdaf9e5d264f08f261f7cfd08.png',
    titleKey: 'sagawa.features.items.travelLight.title',
    descriptionKey: 'sagawa.features.items.travelLight.description',
  },
  {
    image: '7b0b79dd5a438a723886dc40e791e8d4.png',
    titleKey: 'sagawa.features.items.handsFreeTravel.title',
    descriptionKey: 'sagawa.features.items.handsFreeTravel.description',
  },
] as const

const ServiceFeatures = () => (
  <section className="w-full bg-white py-[60px]">
    <div className="mx-auto w-[1200px]">
      <div className="flex flex-col items-center">
        <LangText
          lngKey="sagawa.features.title"
          className="text-[36px] font-bold leading-[50px] text-[#000000]"
        />
        <span className="mt-[20px] h-[4px] w-[104px] rounded-full bg-primary" />
      </div>

      <div className="mt-[48px] grid grid-cols-2 gap-[32px]">
        {FEATURE_ITEMS.map((item) => (
          <article
            key={item.titleKey}
            className="group relative flex items-center overflow-hidden rounded-[20px] border border-[#E3DCDD] px-[32px] transition-[border-color,box-shadow,transform] duration-300 ease-out"
            style={{
              height: 224,
              background: 'linear-gradient(180deg, #FFF7F2 0%, #EDF5FF 100%)',
            }}
          >
            <img
              src={preFixImgUrl(item.image)}
              alt=""
              className="relative z-[2] h-[160px] w-[160px] shrink-0 object-contain transition-transform duration-300 ease-out group-hover:scale-110"
              draggable={false}
            />

            <div className="relative z-[2] ml-[24px] min-w-0 flex-1 text-center">
              <LangText
                lngKey={item.titleKey}
                className="inline-block font-smiley-sans text-[32px] font-medium leading-[38px] text-primary transition-[color,transform] duration-300 ease-out group-hover:translate-x-[3px] group-hover:text-[#126FD9]"
              />
              <LangText
                lngKey={item.descriptionKey}
                className="mt-[16px] block whitespace-pre-line text-[20px] leading-[28px] text-[#979797] transition-colors duration-300 group-hover:text-[#777777]"
              />
            </div>

            <img
              src={circleImage}
              alt=""
              className="pointer-events-none absolute bottom-[-164px] right-[-112px] z-[1] h-[306px] w-[306px] transition-transform duration-500 ease-out group-hover:scale-125"
              aria-hidden
            />
          </article>
        ))}
      </div>
    </div>
  </section>
)

export default ServiceFeatures
